import {
  getEditOrderRedirect,
  canEditOrder,
  getRowLink,
} from '@ldt/api/order_loader/tempus';
import {
  getAvailableActions,
  checkOrderValidationErrors,
  getOrderMissingInfoMessages,
} from '@ldt/features/orders/components/order_actions/tempus';
import {
  getOrderListColumns,
  orderListSearchConfig,
} from '@ldt/features/orders/order_list/tempus';
import {
  getStatusDisplayName,
  getStatusFilterOptions,
} from '@ldt/features/orders/statuses/tempus';
import type { LdtWorkflowDefinition } from '@ldt/workflows/types';
import { SpecimenType } from 'src/types';
import { isCustomerSuccessOrSalesUser, isLabTech } from 'src/utils';

export const tempusWorkflow: LdtWorkflowDefinition = {
  canCreateOrder: false,
  orderListSearchConfig,
  showBillingHoldSection: false,
  showOrderingProviderSection: () =>
    isCustomerSuccessOrSalesUser() || isLabTech(),
  revertStatusOnSaveWithReport: false,
  supportedSpecimenTypes: new Set([SpecimenType.MetastaticProstateBiopsy]),
  canEditOrder,
  getRowLink,
  getStatusDisplayName,
  getStatusFilterOptions,
  getEditOrderRedirect,
  getAvailableActions,
  getOrderMissingInfoMessages,
  checkOrderValidationErrors,
  getOrderListColumns,
};
